/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Role_MainInputs */

const en_contact_role_main = /** @type {(inputs: Contact_Role_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Main contact`)
};

/**
* | output |
* | --- |
* | "Main contact" |
*
* @param {Contact_Role_MainInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const contact_role_main = /** @type {((inputs?: Contact_Role_MainInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Role_MainInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_contact_role_main(inputs)
});